"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.9 25",
    width: "21.9",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.1,25H0.5C0.2,25,0,24.8,0,24.5V3.6c0-0.3,0.2-0.5,0.5-0.5h9.4c0.1,0,0.3,0.1,0.4,0.1l5.2,5.2c0.1,0.1,0.1,0.2,0.1,0.4 v15.7C15.6,24.8,15.4,25,15.1,25z M1,24h13.6V9.1L9.7,4.1H1V24z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.1,9.3H9.9c-0.3,0-0.5-0.2-0.5-0.5V3.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4.7h4.7c0.3,0,0.5,0.2,0.5,0.5 S15.4,9.3,15.1,9.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.4,21.9h-6.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h5.8V5.9L15.9,1H7.3v2.6c0,0.3-0.2,0.5-0.5,0.5S6.3,3.9,6.3,3.6 V0.5C6.3,0.2,6.5,0,6.8,0h9.4c0.1,0,0.3,0.1,0.4,0.1l5.2,5.2c0.1,0.1,0.1,0.2,0.1,0.4v15.7C21.9,21.6,21.6,21.9,21.4,21.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.4,6.2h-5.2c-0.3,0-0.5-0.2-0.5-0.5V0.5c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4.7h4.7c0.3,0,0.5,0.2,0.5,0.5 S21.6,6.2,21.4,6.2z"
  }));
};

exports["default"] = _default;